import styled from 'styled-components';
import Image from 'next/image';
import COLORS from 'styles/colors';

import BREAKPOINTS from 'styles/breakpoints';
import { P1, H2, rem } from 'styles/typography';

const PrizeContainer = styled.div`
  background-color: ${COLORS.forestDark};
  color: ${COLORS.shootoutLightBlue};
  padding: 80px var(--gutter-side);

  ${BREAKPOINTS.small`
    padding-top: 120px;
    padding-bottom: 120px;
  `}
`;

const SectionHeading = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 60px;

  ${BREAKPOINTS.small`
		margin-bottom: 125px;
  `};
`;

const Prize = styled.div`
  max-width: 1160px;
  margin: auto;

  padding-bottom: 40px;
  margin-bottom: 60px;
  border-bottom: 1px solid rgba(225, 225, 225, 0.4);

  :last-child {
    border: none;
    margin-bottom: 0;
  }

  ${BREAKPOINTS.small`
		margin-bottom: 100px;

		:nth-child(even) div {
			flex-direction: row-reverse;
		}		
	`};

  :nth-child(4) h3 {
    background: #cecece;
    background: linear-gradient(to right, #cecece 0%, #8c8c8c 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  :nth-child(5) h3 {
    background: #dfc060;
    background: linear-gradient(to right, #dfc060 0%, #806f37 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const PrizeHeading = styled.h3`
  text-align: center;
  margin-bottom: 40px;
  font-size: ${rem(30)};
  line-height: ${rem(32)};

  ${BREAKPOINTS.small`
		margin-bottom: 60px;
		font-size: ${rem(50)};
	`};
`;

const PrizeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  ${BREAKPOINTS.small`
		flex-direction: row;
		gap: 100px;
	`};
`;

const Content = styled.div`
  ${BREAKPOINTS.small`
		width: 50%;
	`};
`;

const ContentTitle = styled.h4`
  font-size: ${rem(25)};
  line-height: ${rem(28)};

  ${BREAKPOINTS.small`
    line-height: ${rem(50)};
		font-size: ${rem(40)};
	`};
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 250px;

  ${BREAKPOINTS.small`
		height: 300px;
		width: 50%;
	`};
`;

const WhatsOnPrizes = ({ sectionHeading, prizeData }) => {
  return (
    <PrizeContainer>
      {sectionHeading && (
        <SectionHeading>
          <H2>{sectionHeading}</H2>
        </SectionHeading>
      )}

      {prizeData && (
        <>
          {prizeData.map((item, i) => (
            <Prize key={i}>
              {item.heading && <PrizeHeading>{item.heading}</PrizeHeading>}

              <PrizeContent>
                <Content>
                  <ContentTitle>{item.prizeTitle}</ContentTitle>

                  <P1 indent>{item.prizeCopy}</P1>
                </Content>

                <ImageWrapper>
                  <Image
                    src={item.image?.url}
                    alt={item.image?.alt}
                    layout="fill"
                    objectFit="cover"
                  />
                </ImageWrapper>
              </PrizeContent>
            </Prize>
          ))}
        </>
      )}
    </PrizeContainer>
  );
};

export default WhatsOnPrizes;
